<template>
    <div class="custom_select">
        <div class="input_s" ref="column_selectbox" :disabled="disabled" @click="handleColumnSelectBoxClick()">
            <span class="txt">{{ selectedColumnsString }}</span>
            <span class="chevron"><v-icon>mdi-chevron-down</v-icon></span>
        </div>
        <div class="list multiple" ref="column_checkbox" v-show="isShow">
            <div class="item">
                <label class="check_wrap">
                    <input type="checkbox" :checked="isAllSelected" @change="updateAllCheckedColumns()">
                    <span class="checkmark"></span>
                    <span class="txt ellipsis">{{ $t('reservationwindow.header.label_all') }}</span>
                </label>
            </div>
            <ReservationColumnFilterItem v-for="(column, index) in columns" :key="index"
                                         :index="index"
                                         :column="column"
                                         @action_SelectItem="action_SelectItem"
            />
        </div>
    </div>
</template>

<script>
import { deepCopy } from '@/util/deep-copy'

import { sheetFilters, setColumns, toggleColumn, toggleAllColumns, selectedColumns, storedColumns, removeStoredColumns, selectedGroups } from '../../../sheet-filters'
import ReservationColumnFilterItem from './ReservationColumnFilterItem.vue'
import { useQueryClient } from '@tanstack/vue-query'
import store from '@/store'
import { v2ReservationColumnFindRemovedQueryOptions } from '@/composables/queries/v2reservationcolumn/use-v2-reservationcolumn-find-removed-query'
import { useReservationColumnListQuery } from '@/composables/queries/reservationcolumn/use-reservation-column-find-query'

export default {
    setup() {
        const queryClient = useQueryClient()
        // 선언형 구독 — FCM/뮤테이션 invalidation 시 자동 재조회된다 (수동 워처 불필요)
        const { data: fetchedColumns } = useReservationColumnListQuery({
            hospitalID: () => store.state.hospital.selectedHospital?._id,
        })
        return { queryClient, fetchedColumns }
    },
    components: { ReservationColumnFilterItem },

    props: {},
    data() {
        return {
            sheetFilters,

            checkedColumns: [],
            isShow: false,
            disabled: false
        }
    },
    watch: {
        selectedGroups: {
            deep: true,
            handler: function (newValue) {
                this.disabled = newValue.length == 0
                if (this.disabled && !this.isAllSelected) {
                    this.updateAllCheckedColumns()
                }
            }
        },
        fetchedColumns: {
            immediate: true,
            handler: async function (columns) {
                if (!columns) { return }
                // 삭제된 컬럼 반영(storedColumn 정합성) 후 목록 대입 — 기존 재조회 흐름과 동일 순서
                await this.requestFetchRemovedColumns()
                // 컨트롤러 setter 가 입력 배열을 변형할 수 있어 캐시 보호를 위해 복사본 전달
                setColumns(deepCopy(columns))
            }
        }
    },
    computed: {
        columns: function () {
            let groups = deepCopy(this.sheetFilters.groups)
            let columns = deepCopy(this.sheetFilters.columns)
            columns.forEach(c => {
                let groupID = c.groupID
                c.groupID = groups.find(g => g._id == groupID)
            })
            columns.sort((l, r) => {
                if (l.groupID?.order == r.groupID?.order) {
                    return l.order - r.order
                }
                return (l.groupID?.order ?? 0) - (r.groupID?.order ?? 0)
            })
            return columns
        },
        isAllSelected: function () {
            return selectedColumns().length == this.columns.length
        },
        selectedGroups: function () {
            return deepCopy(selectedGroups())
        },
        selectedColumns: function () {
            let columns = deepCopy(this.columns)
            return columns.filter(c => c.isSelected == true)
        },
        selectedColumnsString: function () {
            let count = this.selectedColumns.length
            if (count == this.columns.length) {
                return this.$t('reservationwindow.header.label_staff_column_all')
            } else if (count == 0) {
                return '-'
            } else {
                let name = this.columns.find(c => c._id == this.selectedColumns[0]._id)?.title
                if (count > 1) {
                    name += (' 외 ' + (count - 1) + '명')
                }
                return name
            }
        },
    },
    mounted() {
        document.addEventListener('click', this.handleGlobalClick);
    },
    beforeDestroy() {
        document.removeEventListener('click', this.handleGlobalClick);
    },
    methods: {
        handleColumnSelectBoxClick() {
            if (this.disabled) { return }

            this.isShow = !this.isShow
            if (!this.isShow && this.selectedColumns.length == 0) {
                this.updateAllCheckedColumns()
            }
        },

        handleGlobalClick(event) {
            if (this.isShow) {
                if (!this.$refs.column_selectbox.contains(event.target) && !this.$refs.column_checkbox.contains(event.target)) {
                    this.handleColumnSelectBoxClick()
                }
            }
        },

        updateAllCheckedColumns() {
            toggleAllColumns(!this.isAllSelected)
        },

        action_SelectItem(column) {
            let target = this.sheetFilters.columns.find(c => c._id == column._id)
            let index = this.sheetFilters.columns.indexOf(target)
            toggleColumn(index)
        },

        // MARK: Network
        async requestFetchRemovedColumns() {
            let currentColumnIDs = storedColumns().map(c => c._id)
            if (currentColumnIDs.length == 0) { return }
            try {
                let params = {
                    hospitalID: this.hospital.selectedHospital._id,
                    columnID: currentColumnIDs
                }
                // 봉투 에러(code != 0)는 ApiError로 throw — 아래 catch에서 로그 (기존과 달리 로그가 남는 차이만 있음)
                const data = await this.queryClient.fetchQuery(v2ReservationColumnFindRemovedQueryOptions(params))
                removeStoredColumns(data)
            } catch (err) {
                console.log('reservation columns find removed check error : ', err)
            }
        }
    }
}
</script>